import { createCrudHooks } from "../common/queries";

export const topicApi = {
	...createCrudHooks({
		baseKey: "topics",
		basePath: "/topics",
		getParams: {},
	}),
};
